import {
    ApplicationRef,
    Compiler,
    Injectable,
    Injector,
    NgModuleFactory,
    Type
  } from '@angular/core';
  
  @Injectable({
    providedIn: 'root'
  })
  export class LazyLoaderService {
    constructor(private compiler: Compiler, private injector: Injector) {}
  
    loadModule(path: any, appRef: ApplicationRef) {
      (path() as Promise<NgModuleFactory<any> | Type<any>>)
        .then(elementModuleOrFactory => {
          if (elementModuleOrFactory instanceof NgModuleFactory) {
            // if ViewEngine
            return elementModuleOrFactory;
          } else {
            try {
              // if Ivy
              return this.compiler.compileModuleAsync(elementModuleOrFactory);
            } catch (err) {
              throw err;
            }
          }
        })
        .then(moduleFactory => {
          try {
            const ngModuleRef = moduleFactory.create(this.injector);
            ngModuleRef.injector.get('components').forEach((components: Type<{}>[]) => {
              components.forEach((component: Type<{}>) => {
                const compFactory = ngModuleRef.componentFactoryResolver.resolveComponentFactory(component);
                if (document.querySelector(compFactory.selector)) {
                  appRef.bootstrap(compFactory);
                }
              });
            });
          } catch (err) {
            throw err;
          }
        });
    }
  }